import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";
import RainbowServerFetch from "../Request/RainbowServerFetch";

const LOG_TAG = "SERVICE:PAYMENTS";

export const getListOfPaymentsMethod = (userId) => {
    LogService.trace(LOG_TAG, "getListOfPaymentsMethod");

    return RainbowServerFetch.get(`/api/rainbow/subscription/v1.0/developers/${userId}/payments/methods`)
        .then(response => {
            LogService.info(LOG_TAG, "getListOfPaymentsMethod", "successfully received payment methods");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getListOfPaymentsMethod", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const setAsDefault = (userId, paymentMethodId) => {
    LogService.trace(LOG_TAG, "setAsDefault");

    return RainbowServerFetch.put(`/api/rainbow/subscription/v1.0/developers/${userId}/payments/methods/${paymentMethodId}/default`)
        .then(response => {
            LogService.info(LOG_TAG, "setAsDefault", "successfully defined the default payment methods");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "setAsDefault", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const deletePaymentMethod = (userId, paymentMethodId) => {
    LogService.trace(LOG_TAG, "deletePaymentMethod");

    return RainbowServerFetch.delete(`/api/rainbow/subscription/v1.0/developers/${userId}/payments/methods/${paymentMethodId}`)
        .then(response => {
            LogService.info(LOG_TAG, "deletePaymentMethod", "successfully to delete payment method");
            return Promise.resolve();
        })
        .catch(error => {
            LogService.error(LOG_TAG, "deletePaymentMethod", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const subscribeAnApplication = (userId, applicationId) => {
    LogService.trace(LOG_TAG, "subscribeAnApplication");

    const body = JSON.stringify({ applicationId: applicationId });

    return RainbowServerFetch.post("/api/rainbow/subscription/v1.0/developers/" + userId + "/subscriptions", body)
        .then(response => {
            LogService.info(LOG_TAG, "subscribeAnApplication", "successfully defined the default payment methods");
            return Promise.resolve(response.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "subscribeAnApplication", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const getSubscriptionById = (userId, subscriptionId) => {
    LogService.trace(LOG_TAG, "getSubscriptionById");

    return RainbowServerFetch.get("/api/rainbow/subscription/v1.0/developers/" + userId + "/subscriptions/" + subscriptionId)
        .then(response => {
            LogService.info(LOG_TAG, "getSubscriptionById", "successfull");
            return Promise.resolve(response.subscription);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getSubscriptionById", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const getSignatureForPaymentMethod = (userId, method) => {
    LogService.trace(LOG_TAG, "getSignatureForPaymentMethod");

    return RainbowServerFetch.get(`/api/rainbow/subscription/v1.0/developers/${userId}/payments/rsa-signatures/${method}`)
        .then(response => {
            LogService.info(LOG_TAG, "getSignatureForPaymentMethod", "successfully received the signature for method:" + method);
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getSignatureForPaymentMethod", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}